<template>
  <v-container class="fill-height pa-0 ma-0" fluid>
    <v-row class="ma-0 pa-0 fill-height">
      <v-col cols="12" class="d-flex pt-0 pr-0 ma-0 justify-center align-baseline fill-height"
             :style="$vuetify.breakpoint.lgAndUp ? 'padding-left: 210px' : 'padding-left: 50px'">
        <transition
            enter-active-class="transition-ease-in-out"
            leave-active-class="transition-ease-in-out">
          <router-view></router-view>
        </transition>
      </v-col>
    </v-row>
    <v-navigation-drawer
        class="elevation-6"
        :style="$vuetify.breakpoint.lgAndUp ? 'z-index: 0' : 'z-index: 2'"
        :value="true"
        :width="$vuetify.breakpoint.lgAndUp ? 200 : 50"
        :mini-variant="$vuetify.breakpoint.mobile"
        permanent
        hide-overlay
        color="primary"
        fixed>
      <v-list-item two-line style="padding-top: 70px">
        <v-list-item-avatar size="20" color="success">
          <v-icon small color="primary">mdi-account-circle</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="white--text">{{ user.name }}</v-list-item-title>
          <v-list-item-subtitle class="white--text">{{ user.email }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

      <v-list-item-group dark>
        <template v-for="(item, i) in menu">
          <v-list-item :key="i"
                       @click="$router.push({name: item.route}).catch( error => {})">
            <v-list-item-icon class="d-flex justify-center mr-3">
              <v-icon small>{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content class="white--text">
              <v-list-item-title>{{ item.content }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
        <v-divider></v-divider>
        <v-list-item @click="logout">
          <v-list-item-icon class="d-flex justify-center mr-3">
            <v-icon small>mdi-logout</v-icon>
          </v-list-item-icon>
          <v-list-item-content class="white--text"
                               v-if="$vuetify.breakpoint.lgAndUp">{{ $t('logout') }}</v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-navigation-drawer>
  </v-container>
</template>

<script>
import Pusher from 'pusher-js'
export default {
  name: "Dashboard",
  data () {
    return {
      pusher: new Pusher(process.env.VUE_APP_PUSHER_APP_KEY, {
        cluster: process.env.VUE_APP_PUSHER_APP_CLUSTER,
        forceTLS: true
      })
    }
  },
  mounted() {
    this.subscribe()
  },
  beforeDestroy() {
    this.unbind()
  },
  methods: {
    logout () {
      this.$http.post('api/v2/auth/logout')
          .then(response => {
            this.$store.dispatch('setAlert', {show: true, type: 'success', message: response.data.message})
            this.$store.dispatch('setAuthorization', null)
            this.$store.dispatch('setUser', null)
            this.$router.push({ name: 'main' })
          })
    },
    subscribe () {
      this.pusher
          .subscribe('channel.business_created')
          .bind('event.business_added', () => {
            this.$root.$emit('update')
          })
    },
    unbind () {
      this.pusher
          .unbind('event.business_added')
    }
  },
  computed: {
    menu () {
      return this.$store.getters.GET_USER && this.$store.getters.GET_USER.role.includes('admin') ?
          this.$t('adminMenu') : this.$t('userMenu')
    },
    user () {
      return this.$store.getters.GET_USER ? this.$store.getters.GET_USER : {}
    }
  }
}
</script>

<style scoped>

</style>
